// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
function setUserDataToStore(data: any) {
  const hubs: any = []
  const warehouses: any = []
  const authorities: any = []

  data.location_roles.forEach((el: any) => {
    if (el.location_type === 'HUB') {
      hubs.push({ ...el, name: el.location_name })
    } else {
      warehouses.push({ ...el, name: el.location_name })
    }
  })
  data.authorities.forEach((el: any) => {
    authorities.push(el.name)
  })

  const isSuperAdmin = authorities.some((el: any) => el === 'AUTH_ADMIN')

  return {
    ...data,
    isSuperAdmin,
    warehouses,
    hubs,
  }
}

export default setUserDataToStore
